module.exports = __webpack_public_path__ + "img/lsjn1.0ad30a00.jpg";